<template>
  <v-row class="ma-0">
    <v-sheet style="height: 100%; width: 100%">
      <v-container fluid>
        <v-card elevation="0" min-width="100%">
          <job-list
            ref="tasksList"
            :tableSearch="[['project.id', '==', id]]"
            :adminView="adminView"
            :userData="userData"
            :showBulkUpdate.sync="bulkUpdatePopupVisibleInternal"
            :bulkEditing.sync="bulkEditingInternal"
          ></job-list>
        </v-card>
      </v-container>
    </v-sheet>
  </v-row>
</template>

<script>
import JobList from '@/views/jobs/List.vue'
import {
  hasAccessRightForCollection,
  AccessRightWrite,
} from '@/plugins/feature'

export default {
  props: ['id', 'bulkUpdatePopupVisible', 'bulkEditing'],
  components: {
    JobList,
  },
  data() {
    return {
      userData: null,
      bulkUpdatePopupVisibleInternal: false,
      bulkEditingInternal: false,
    }
  },
  watch: {
    bulkUpdatePopupVisibleInternal(newVal) {
      this.$emit('update:bulkUpdatePopupVisible', newVal)
    },
    bulkEditingInternal(newVal) {
      this.$emit('update:bulkEditing', newVal)
    },
    bulkEditing(newVal) {
      this.bulkEditingInternal = newVal
    },
    bulkUpdatePopupVisible(newVal) {
      this.bulkUpdatePopupVisibleInternal = newVal
    },
  },
  computed: {
    adminView() {
      return hasAccessRightForCollection('jobs', AccessRightWrite)
    },
  },
  methods: {
    rowClicked(data) {
      this.$router.push({
        name: 'job-details',
        params: { id: data.id },
      })
    },
    getProjectName(item) {
      return item.project?.name ?? ''
    },
    getVisibleAssignees(item) {
      const result = []

      for (let i = 0; i < Math.min(item.assignees?.length ?? 0, 2); i++) {
        result.push(item.assignees[i])
      }

      return result
    },
    getExtraAssigneesCount(item) {
      return Math.max((item.assignees?.length ?? 0) - 2, 0)
    },
  },
}
</script>
